<template>
  <div class="drawer-detail">
    <div class="info-box">
      <div v-for="field in fields" :key="field" class="search-row">
        <span class="label">{{translateTag[field]||field}}:</span>
        <span v-if="field==='平台等级'" class="value">{{company[field]?`${translateLevel[company[field]]}（${company[field]}）`:company[field]}}</span>
        <span v-else-if="field==='排名/行业'" class="value">{{company.行业}}/{{company.排名}}</span>
        <span v-else-if="field==='公司类型'" class="value">{{ companyType.length===0 ? '--' : companyType.join('、')}}</span>
        <span v-else class="value">{{ company[field] || '--' }}</span>
      </div>
    </div>
    <!-- <div v-if="Array.isArray(company.branch)&&company.branch.length>0" class="branch-box">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="breadcrumb-item">
            <div class="vertical-bar"></div>
            分支机构
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="branch">
        <div class="flex mb10">
          <span class="branch-title">主机构：</span>
          <span
            v-if="masterBranch"
            class="link-text"
            @click="openCompany(masterBranch)"
          >{{masterBranch.公司名称}}</span>
        </div>
        <div class="flex">
          <span class="branch-title">子机构：</span>
          <div>
            <div v-for="item in branch" :key="item._id">
              <span class="link-text" @click="openCompany(item)">{{item.公司名称}}</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import * as commonvariant from '../../../../../company/statistics/variant/commonvariant'

export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      translateTag: {
        行业: '公司行业',
        平台等级: '公司平台',
        办公地: '主要办公地',
        网址: '公司官网',
      },
      translateLevel: {
        A: '大平台',
        B: '中平台',
        C: '小平台',
      },
      masterBranch: null,
      suspectedCompanies: [],
      branch: [],
      translate: commonvariant.风格对应,
    }
  },
  computed: {
    companyType() {
      if (!this.company['业务特点/风格/资源来源']) {
        return []
      } else {
        const keys = Object.keys(this.company['业务特点/风格/资源来源'].keywords)
          .filter((k) => this.company['业务特点/风格/资源来源'].keywords[k])
          .map((k) => commonvariant.风格对应[k])
        return keys
      }
    },
    fields() {
      const arr = [
        '平台等级',
        '排名/行业',
        '公司类型',
        '公司性质',
        '人员受认可度',
        '激励机制',
        '固定薪酬',
        '人员稳定性',
        '币种',
        '管理规模',
      ]
      return arr
    },
  },
  watch: {
    company: {
      handler(newValue, oldValue) {
        if (newValue && newValue.公司名称 && !oldValue) this.init()
        else if (newValue && oldValue && newValue.公司名称 !== oldValue.公司名称) this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    splitUrl(url = '') {
      const val = url ? url.replace(/[,，;；]/g, ';') : ''
      return val
        .split(';')
        .filter(v => v)
        .map(v => (v.includes('http') ? v : `http://${v}`))
    },
    async init() {
      await Promise.all([this.getSuspectedBranchCompany(), this.getBrachCompany()])
      const { branch = [] } = this.company
      this.searchKeyword = ''
      if (Array.isArray(branch)) {
        this.masterBranch = { _id: this.company._id, 公司名称: this.company.公司名称 }
        this.suspectedCompanies = this.suspectedCompanies.filter(
          val => !branch.includes(val._id) && val._id !== this.company._id,
        )
      } else {
        this.masterBranch = null
        const index = this.suspectedCompanies.findIndex(v => v._id === this.company._id)
        const temp = this.suspectedCompanies.splice(index, 1)
        this.suspectedCompanies.unshift(...temp)
      }
    },
    async getSuspectedBranchCompany() {
      if (!this.company.公司名称) return
      const res = await app.service('company').getSuspectedBranchCompany(this.company.公司名称)
      if (res.status !== 'success') return this.$message.error(res.msg)
      this.suspectedCompanies = res.data
    },
    async getBrachCompany() {
      const { branch } = this.company
      if (!Array.isArray(branch) || branch.length === 0) return (this.branch = [])
      const res = await app.service('company').getBranch(branch)
      if (res.status !== 'success') return this.$message.error(res.msg)
      this.branch = res.data
    },
    openCompany(company) {
      window.open(`${window.origin}#/company/${company._id}`)
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.branch {
  font-size: 14px;
}
.branch-title {
  min-width: 50px;
}
.branch-tag {
  display: inline-block;
  background-color: #409eff;
  color: #fff;
  min-width: 200px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border-radius: 4px;
  margin-bottom: 4px;
  cursor: pointer;
}
.ml15 {
  margin-left: 15px;
}
.info-box {
  padding: 0 15px 10px;
  margin: 0 -15px;
}
.branch-box {
  padding: 0 15px 10px;
  border-top: 6px solid #eff2f5;
  margin: 0 -15px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
